import { motion } from "framer-motion";
import { Petal } from "@/components/site/Petal";

const StageBlock = ({ s, i }) => (
  <motion.article
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
    data-testid={`journey-stage-${s.name.toLowerCase()}`}
    className="relative grid gap-6 border-t border-[#e4dacb] py-12 md:grid-cols-[96px_minmax(0,1fr)] md:gap-x-8 md:gap-y-6 lg:grid-cols-[112px_minmax(0,1.2fr)_minmax(0,1fr)] lg:gap-x-12 lg:py-16"
  >
    <div className="flex items-start justify-center gap-5 sm:justify-start md:row-span-2 md:flex-col md:gap-6 lg:row-span-1">
      <span className="font-display text-7xl leading-none md:text-8xl" style={{ color: s.color, opacity: 0.85 }}>{s.n}</span>
      <div className="flex flex-col gap-2 pt-2 md:pt-0">
        <Petal color={s.color} size={22} />
        <span className="text-[0.8125rem] font-semibold uppercase tracking-[0.12em] text-[#5d544c]">{s.days}</span>
      </div>
    </div>
    <div className="min-w-0">
      <h3 className="font-display text-center text-5xl font-medium leading-none text-[#221e1b] sm:text-left sm:text-6xl">{s.name}</h3>
      <p className="mt-3 flex flex-col gap-1 text-center sm:text-left">
        <em className="font-display text-2xl font-medium text-[#7a5615]">{s.kosha}</em>
        <span className="text-base leading-relaxed text-[#5d544c]">{s.meaning}</span>
      </p>
      <p className="mt-6 text-[1.0625rem] leading-[1.75] text-[#5d544c] sm:text-lg">{s.long}</p>
    </div>
    <div className="rounded-[1.5rem] border border-[#e4dacb] bg-[#fffaf3] p-6 md:col-start-2 md:self-start lg:col-start-auto lg:p-8">
      <p className="text-[0.8125rem] font-semibold uppercase tracking-[0.12em] text-[#5d544c]">What you&apos;ll explore</p>
      <ul className="mt-5 space-y-3">
        {s.explore.map((x) => (
          <li key={x} className="flex items-start gap-3 text-base leading-relaxed text-[#221e1b] sm:text-[1.0625rem]">
            <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full" style={{ background: s.color }} />
            {x}
          </li>
        ))}
      </ul>
      <p className="mt-6 border-t border-[#e4dacb] pt-4 text-base text-[#5d544c]">
        Element: <span className="font-semibold text-[#221e1b]">{s.element}</span>
      </p>
    </div>
    {i === 0 && <span className="sr-only">Stage one of five</span>}
  </motion.article>
);

export const StagesFlow = ({ stages }) => (
  <div className="relative">
    {stages.map((s, i) => <StageBlock key={s.n} s={s} i={i} />)}
  </div>
);
